/**
 * Copyright 2026 ForgeRock AS. All Rights Reserved
 *
 * Use of this code requires a commercial software license with ForgeRock AS
 * or with one of its affiliates. All use shall be exclusively subject
 * to such license between the licensee and ForgeRock AS.
 */

import { useAuth } from './useAuth';
import menuItems from '../../../config/menus/menus.idm';
import routes from '../../../config/routes/routes.idm';
import store from '@/store';
import router from '@/router';

const { isAuthenticated, restoreAdminSession } = useAuth();

export async function routerGuard(to, from, next) {
  if (to.name !== 'Login' && !isAuthenticated()) {
    try {
      await restoreAdminSession();
      next();
    } catch {
      next({ name: 'Login' });
    }
  } else {
    next();
  }
}

function setRoutes() {
  routes.forEach(router.addRoute);
}

function setMenuItems() {
  store.commit('setMenuItems', menuItems.sideMenu);
}

export default function initialize(loadApp) {
  store.commit('setEnvironment', process.env);
  store.commit('SharedStore/setBaseURLs', process.env);
  store.commit('SharedStore/setCurrentPackage', 'admin');
  store.commit('SharedStore/setFeatureFlags', process.env);

  const { initializeLogout } = useAuth();
  initializeLogout();
  setRoutes();
  setMenuItems();
  loadApp();
}
